// Generated by purs version 0.14.5
"use strict";
var Data_Show = require("../Data.Show/index.js");
var pa = function (n) {
    return "pa" + Data_Show.show(Data_Show.showInt)(n);
};
module.exports = {
    pa: pa
};
